// 003: the three operations this feature consumes (contracts/consumes.md), through the generated
// client. Each throws one AppError on failure (`unwrap`). Screens read them through JoinClient so
// tests can inject fakes; the app uses the authFetch client (the public lookup ignores a token).
import { createContext, useContext } from "react";

import { api } from "@/api";
import { type ApiClient, unwrap } from "@/api/client";
import type { Api } from "@/api/types";

export function getSchoolByJoinCode(
  client: ApiClient,
  code: string,
): Promise<Api["SchoolByCode"]> {
  return unwrap(
    client.GET("/api/v1/public/schools/by-code/{code}", {
      params: { path: { code } },
    }),
  );
}

export function listMyStudents(client: ApiClient): Promise<Api["StudentList"]> {
  return unwrap(client.GET("/api/v1/me/students"));
}

export async function enableParentRole(client: ApiClient): Promise<void> {
  await unwrap(client.POST("/api/v1/me/parent-role"));
}

export type JoinClient = {
  getSchoolByJoinCode(code: string): Promise<Api["SchoolByCode"]>;
  listMyStudents(): Promise<Api["StudentList"]>;
  enableParentRole(): Promise<void>;
};

export const appJoinClient: JoinClient = {
  getSchoolByJoinCode: (code) => getSchoolByJoinCode(api, code),
  listMyStudents: () => listMyStudents(api),
  enableParentRole: () => enableParentRole(api),
};

export const JoinClientContext = createContext<JoinClient>(appJoinClient);
export const useJoinClient = () => useContext(JoinClientContext);
